export const breedOptions = [
  { value: "european", label: "Европейска" },
  { value: "shotland", label: "Шотландска клепоуха" },
  { value: "exotic_shorthair", label: "Екзотична късокосместа (Exotic Shorthair)" },
  { value: "persian", label: "Персийска котка (Persian cat)" },
  { value: "ragdoll", label: "Рагдол (Ragdoll)" },
  { value: "sacred_birman", label: "Бирманска котка (Sacred Birman)" },
  { value: "turkish_van", label: "Турски Ван (Turkish Van)" },
  { value: "american_curl_long", label: "Американски кърл, дългокосмест" },
  { value: "american_curl_short", label: "Американски кърл, късокосмест" },
  { value: "laperm_long", label: "LaPerm Longhair" },
  { value: "laperm_short", label: "LaPerm Shorthair" },
  { value: "maine_coon", label: "Мейн Кун (Maine Coon)" },
  { value: "neva_masquerade", label: "Невска маскарадна" },
  { value: "norwegian_forest", label: "Норвежка горска котка" },
  { value: "siberian", label: "Сибирска котка (Siberian cat)" },
  { value: "turkish_angora", label: "Турска ангорска котка" },
  { value: "bengal", label: "Бенгалска котка (Bengal cat)" },
  { value: "british_longhair", label: "Британска дългокосместа" },
  { value: "burmilla", label: "Бурмила (Burmilla)" },
  { value: "british_shorthair", label: "Британска късокосместа" },
  { value: "burmese", label: "Бурманска котка (Burmese cat)" },
  { value: "chartreux", label: "Шартрьо (Chartreux)" },
  { value: "cymric", label: "Кимрик (Cymric)" },
  { value: "kurilian_bobtail", label: "Курилски бобтейл" },
  { value: "korat", label: "Корат (Korat)" },
  { value: "manx", label: "Манкс (Manx cat)" },
  { value: "egyptian_mau", label: "Египетска мау (Egyptian Mau)" },
  { value: "ocicat", label: "Оцикет (Ocicat)" },
  { value: "singapura", label: "Сингапурска котка (Singapura cat)" },
  { value: "snowshoe", label: "Сноушу (Snowshoe cat)" },
  { value: "sokoke", label: "Кенийска горска котка (Sokoke)" },
  { value: "selkirk_rex_long", label: "Селкърк Рекс, дългокосмест" },
  { value: "selkirk_rex_short", label: "Селкърк Рекс, късокосмест" },
  { value: "abyssinian", label: "Абисинска котка (Abyssinian)" },
  { value: "balinese", label: "Балийска котка (Balinese cat)" },
  { value: "cornish_rex", label: "Корниш рекс" },
  { value: "devon_rex", label: "Девън рекс" },
  { value: "donskoy", label: "Донски сфинкс (Donskoy)" },
  { value: "german_rex", label: "Герман рекс" },
  { value: "japanese_bobtail", label: "Японски бобтейл" },
  { value: "oriental_longhair", label: "Ориенталска дългокосместа" },
  { value: "oriental_shorthair", label: "Ориенталска късокосместа" },
  { value: "peterbald", label: "Петерболд (Peterbald)" },
  { value: "russian_blue", label: "Руска синя котка" },
  { value: "siamese", label: "Сиамска котка (Siamese)" },
  { value: "somali", label: "Сомали (Somali cat)" },
  { value: "sphynx", label: "Канадски сфинкс (Sphynx cat)" },
  { value: "thai", label: "Тайска котка (Thai cat)" }
]
